import React, { createContext, useContext, useState, useEffect } from 'react';
import { contentService } from '../services/contentService';

const FeatureFlagContext = createContext(null);

export const FeatureFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState({
    auto_registration_enabled: true // Default fallback
  });
  const [loading, setLoading] = useState(true);

  const loadFlags = async () => {
    try {
      // We use getWebsiteContent because it handles caching and versioning
      // In a real scenario, you might want a dedicated lightweight endpoint for just flags
      const content = await contentService.getWebsiteContent();
      
      if (content && content.feature_flags) {
        setFlags(prev => {
          // Only update if changed to avoid unnecessary re-renders
          if (JSON.stringify(prev) !== JSON.stringify(content.feature_flags)) {
            return content.feature_flags;
          }
          return prev;
        });
      }
    } catch (error) {
      console.error('Error loading feature flags:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial load
    loadFlags();

    // Poll for updates every 30 seconds
    const intervalId = setInterval(loadFlags, 30000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <FeatureFlagContext.Provider value={{ flags, loading }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlag = (flagName) => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error('useFeatureFlag must be used within a FeatureFlagProvider');
  }
  
  if (!flagName) return context.flags;
  
  return context.flags[flagName] ?? false;
};
